import UploadOutlined from '@ant-design/icons/UploadOutlined';
import PictureOutlined from '@ant-design/icons/PictureOutlined';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import message from 'antd/lib/message';
import Model from 'antd/lib/modal';
import Select from 'antd/lib/select';
import Upload from 'antd/lib/upload';
import React, { useContext, useEffect, useState } from 'react';
import { axiosGetCall, axiosPostCall } from '../../api/axiosCall';
import { API_END_POINT, SOMETHING_WENT_WRONG } from '../../constant/constants';
import { AuthContext } from '../../context/AuthProvider';
import { uploadFile, S3ImageFolder } from '../../utils/imageUploader';

const { Option } = Select;

function AddBannerImage({ isOpen, handleModelClose, callback }) {
  const [addForm] = Form.useForm();
  const { token } = useContext(AuthContext);

  const [fileList, setFileList] = useState([]);
  const [productCategoryList, setProductCategoryList] = useState([]);

  useEffect(() => {
    getCategoryList();
  }, []);

  async function getCategoryList() {
    try {
      const res = await axiosGetCall({
        apiEndPoint: API_END_POINT.GET_PRODUCT_CATEGORY_LIST,
        header: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.hideErrorFromUser) {
        setProductCategoryList(res.data);
      } else {
        message.error(res.error.message);
      }
    } catch (error) {
      message.error(SOMETHING_WENT_WRONG);
    }
  }

  const handleClose = () => {
    handleModelClose();
    setFileList([]);
    addForm.resetFields();
  };

  async function addProductCategory({ fileURL }) {
    try {
      const res = await axiosPostCall({
        apiEndPoint: API_END_POINT.ADD_BANNER_IMAGE,
        header: {
          Authorization: `Bearer ${token}`,
        },
        body: {
          bannerName: addForm.getFieldValue().name,
          bannerImagePath: fileURL,
          productCategoryId: addForm.getFieldValue().productCategoryId,
        },
      });
      if (res?.hideErrorFromUser) {
        message.success(res.data.message);
        callback();
        handleClose();
        return;
      } else {
        message.error(res?.error?.message);
      }
    } catch (error) {
      message.error(SOMETHING_WENT_WRONG);
    }
  }

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  async function handleAddCategory() {
    try {
      const list = [];
      for (const file of fileList) {
        const data = await uploadFile(file, S3ImageFolder.Banner, token);
        list.push(data);
      }
      await addProductCategory({ fileURL: list[0] });
    } catch (error) {
      console.error('uploadFile', error);
      return false;
    }
  }

  const uploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      if (fileList.length < 1) {
        setFileList([...fileList, file]);
      } else {
        message.error('Max image upload limit reached');
      }
      return false;
    },
    fileList,
  };

  return (
    <div>
      <Model
        open={isOpen}
        onCancel={handleClose}
        closable={false}
        footer={null}
      >
        <div className='px-6 pb-4'>
          <div className='flex items-center gap-3 mb-4'>
            <div className='p-2 rounded-lg shadow bg-gradient-to-r from-blue-500 to-purple-600'>
              <PictureOutlined className='text-white text-lg' />
            </div>
            <h2 className='text-xl font-bold text-text m-0'>Add Banner</h2>
          </div>

          <div className='bg-surface border border-border rounded-xl shadow p-4'>
            <Form
              form={addForm}
              layout='vertical'
            >
              <Form.Item
                label='Banner Name'
                name='name'
              >
                <Input
                  name='bannerName'
                  placeholder='Enter banner name'
                />
              </Form.Item>
              <Form.Item
                label='Product Category'
                name='productCategoryId'
              >
                <Select
                  placeholder='Select a Product Category'
                  showSearch
                  optionFilterProp='children'
                  filterOption={(input, option) =>
                    (option?.children ?? '')
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {productCategoryList.map((category) => (
                    <Option
                      key={category.productCategoryId}
                      value={category.productCategoryId}
                    >
                      {category.categoryName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label='Upload'
                valuePropName='fileList'
                getValueFromEvent={normFile}
              >
                <Upload
                  accept='image/*'
                  {...uploadProps}
                  multiple={false}
                  maxCount={1}
                >
                  <Button
                    type='dashed'
                    icon={<UploadOutlined />}
                    className='border-primary text-primary'
                  >
                    Click to Upload
                  </Button>
                </Upload>
              </Form.Item>
            </Form>

            <div className='flex justify-end gap-3 pt-2'>
              <Button
                onClick={handleModelClose}
                className='w-28 bg-surface border border-border text-text hover:text-primary hover:border-primary'
              >
                Close
              </Button>
              <Button
                onClick={handleAddCategory}
                type='primary'
                className='w-32 border-none bg-gradient-to-r from-blue-500 to-purple-600 shadow hover:shadow-md'
              >
                Add Banner
              </Button>
            </div>
          </div>
        </div>
      </Model>
    </div>
  );
}

export default AddBannerImage;
